import { del, get, post, put } from '@api/request';

export async function fetchPersonalDepreciationMethods(
  { appraisalService },
  authenticationToken,
  { methodYr },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationmethods/${methodYr}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertPersonalDepreciationMethod(
  { appraisalService },
  authenticationToken,
  { methodYr, payload },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationmethods/${methodYr}`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function fetchPersonalDepreciationMethod(
  { appraisalService },
  authenticationToken,
  { methodID },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationmethod/${methodID}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function updatePersonalDepreciationMethod(
  { appraisalService },
  authenticationToken,
  { methodID, payload },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationmethod/${methodID}`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function deletePersonalDepreciationMethod(
  { appraisalService },
  authenticationToken,
  { methodID },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationmethod/${methodID}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function fetchDepreciationSchedules(
  { appraisalService },
  authenticationToken,
  { methodYr },
) {
  const url = `${appraisalService}/appraisal/pricingschedules?year=${methodYr}&pricingType=BPP-Depreciation&codesOnly=1`;
  const { body } = await get(authenticationToken, url);

  return body;
}
